import {
  GSImage,
  GSItemList,
  defaultGapping,
  defaultLayouts,
  defaultTypography,
  useMediaQuery,
} from "golfstatus_react_components";
import {
  selectTournamentSponsors,
  selectTournamentSponsorshipTiers,
} from "../../reducers/tournamentSlice";
import { useSelector } from "react-redux";

const TournamentSponsorsWidget = () => {
  const { isPhone, isTablet } = useMediaQuery();

  const sponsorships = useSelector(selectTournamentSponsors);
  const sponsorshipTiers = useSelector(selectTournamentSponsorshipTiers);

  const defaultTier = sponsorshipTiers?.find?.(
    (tier) => tier?.sponsorshipTierType === "default"
  );

  const defaultTieredSponsors = sponsorships.filter(
    (s) => s?.sponsorshipTierId === defaultTier?.id
  );

  return (
    <div style={{ ...defaultLayouts.vStack, ...defaultGapping.largeGap }}>
      <div style={{ ...defaultTypography.headline3 }}>{defaultTier?.name}</div>
      <GSItemList
        style={{ ...defaultLayouts.fullWidth }}
        type="inline-grid medium-large-gap"
        gridColumns={isTablet() ? 4 : isPhone() ? 2 : 6}
        items={defaultTieredSponsors}
        listItem={(sponsorship) => (
          <GSImage src={sponsorship.logo} size="small" />
        )}
      />
    </div>
  );
};

export default TournamentSponsorsWidget;
